import React, { useState, useEffect } from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_b01f443b-34d5-4fc7-9e0b-ca007ef072d9/artifacts/tahd0sec_IMG_0935.jpeg";

export default function SplashScreen({ onComplete }) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(onComplete, 500);
    }, 2000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div 
      className={`fixed inset-0 z-[100] bg-white flex flex-col items-center justify-center transition-opacity duration-500 ${fadeOut ? 'opacity-0' : 'opacity-100'}`}
      data-testid="splash-screen"
    >
      {/* Logo */}
      <div className="mb-6 animate-fade-in">
        <img 
          src={LOGO_URL} 
          alt="ZD Golf Team" 
          className="w-40 h-auto"
        />
      </div>

      {/* Team Name */}
      <h1 className="font-heading text-2xl font-bold text-black mb-2 animate-slide-up">
        ZD Golf Team
      </h1>

      {/* Loading indicator */}
      <div className="mt-8">
        <div className="w-8 h-8 border-3 border-golf-green border-t-transparent rounded-full animate-spin"></div>
      </div>

      {/* Made by */}
      <p className="absolute bottom-8 text-sm text-apple-text-tertiary animate-fade-in" style={{ animationDelay: '0.5s' }}>
        Made by Sebastian Lukonin
      </p>
    </div>
  );
}
